module.exports = {"audiences":["allMembers"],"experimentVersion":"v3","experimentAllocation":0.4,"defaultWeight":1,"defaults":{"showSurvey":false},"autoTrack":true,"variations":[{"name":"showSurvey","weight":1,"values":{"showSurvey":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/npsSurvey.json
// module id = bGHy
// module chunks = 1